import { useDictionary } from '@adamlip/okeoke.client';
import { createContext, useContext, useEffect, useState } from 'react';
import { UserContext } from './UserContext';
import CouponModalV2 from 'components/Modals/CouponModalV2';
import AddCouponModal from 'components/_VIP/AddCouponModal';
import toast from 'react-hot-toast';
import OneToOneModal from 'views/_VIP/Coupons/OneToOneModal';
import ClaimPointModal from 'components/_VIP/ClaimPointModal';
import SendVibration from 'utils/Helpers-v1/SendVibration';
import AutoAddItemsModal from 'views/_VIP/Coupons/AutoAddItemsModal';

const CouponContext = createContext();

const CouponContextProvider = ({ children }) => {
	const { getValue } = useDictionary();

	const { coupons, activateCoupon, claimCoupon, refreshCoupons } = useContext(UserContext);

	const [couponModalOpen, setCouponModalOpen] = useState(false);
	const [selectedCoupon, setSelectedCoupon] = useState(null);
	const [addCouponModalOpen, setAddCouponModalOpen] = useState(false);
	const [activateInProgress, setActivateInProgress] = useState(false);
	const [currentCoupon, setCurrentCoupon] = useState(null);
	const [couponList, setCouponList] = useState(null);
	const [claimPointModalOpen, setClaimPoinModalOpen] = useState(null);

	const [oneToOneModalOpen, setOneToOneModalOpen] = useState(null);
	const [autoAddItemsModal, setAutoAddItemsModal] = useState(null);

	const handleActivateCoupon = (coupon) => {
		if (coupon?.active) return null;
		if (coupon.couponType === 'oneToOne') {
			setAddCouponModalOpen(false)
			setOneToOneModalOpen(coupon);
		} else {
			if (coupon.attributes.autoAddItems || coupon.attributes.autoAddReqItems) {
				setAddCouponModalOpen(false)
				setAutoAddItemsModal(coupon)
			} else {
				setActivateInProgress(coupon?.code);
				activateCoupon(coupon?.code, false).then((response) => {
					if (response?.success) {
						toast.success(getValue('app_v2_coupons_activated'));
						SendVibration('success');

						refreshCoupons();
						setCurrentCoupon(response.data);
					}
					setActivateInProgress(false);
				});
			}
		}
	};

	const handleDeActivateCoupon = (coupon) => {
		if (!coupon?.active) return null;
		setActivateInProgress(coupon?.code);
		activateCoupon(coupon?.code, true).then((response) => {
			if (response?.success) {
				SendVibration('success');
				toast.success(getValue('app_v2_coupons_deactivated'));
				refreshCoupons();
				setCurrentCoupon(response.data);
			}
			setActivateInProgress(false);
		});
	};

	const handleClaimCoupon = (coupon) => {
		if (coupon.isClaimed) return null;
		setActivateInProgress(coupon?.code);
		claimCoupon(coupon?.code).then((response) => {
			if (response?.success) {
				SendVibration('success');
				toast.success(getValue('app_v2_coupons_claimed'));
				refreshCoupons();
				setCurrentCoupon(response.data);
			}
			setActivateInProgress(false);
		});
	};

	const openCouponModal = (coupon) => {
		if (coupon != null) {
			SendVibration('light');

			setCouponModalOpen(true);
			setSelectedCoupon(coupon);
		}
	};

	const onOneToOneActivate = () => {
		setCouponModalOpen(false);
		setAddCouponModalOpen(false);
	};

	const onAutoAddActivate = () => {
		setCouponModalOpen(false);
		setAutoAddItemsModal(false);
	};

	useEffect(() => {
		setCouponList(coupons);
	}, [coupons]);

	return (
		<CouponContext.Provider
			value={{
				couponList,
				handleClaimCoupon,
				openCouponModal,
				activateInProgress,
				handleActivateCoupon,
				handleDeActivateCoupon,
				couponModalOpen,
				setCouponModalOpen,
				currentCoupon,
				setCurrentCoupon,
				setAddCouponModalOpen,
				setClaimPoinModalOpen,
			}}>
			{children}
			<CouponModalV2
				isOpen={couponModalOpen}
				setIsOpen={setCouponModalOpen}
				coupon={selectedCoupon}
				setCurrentCoupon={setCurrentCoupon}
				currentCoupon={currentCoupon}
				handleActivateCoupon={handleActivateCoupon}
				handleDeActivateCoupon={handleDeActivateCoupon}
				activateInProgress={activateInProgress}
			/>
			<AddCouponModal isOpen={addCouponModalOpen} setIsOpen={setAddCouponModalOpen} />
			<ClaimPointModal isOpen={claimPointModalOpen != null} setIsOpen={() => setClaimPoinModalOpen(null)} coupon={claimPointModalOpen} />
			<OneToOneModal isOpen={oneToOneModalOpen != null} setCouponModalOpen={setCouponModalOpen} setIsOpen={() => setOneToOneModalOpen(null)} selectedCoupon={oneToOneModalOpen} onActivate={onOneToOneActivate} />
			<AutoAddItemsModal isOpen={autoAddItemsModal != null} setCouponModalOpen={setCouponModalOpen} setIsOpen={() => setAutoAddItemsModal(null)} selectedCoupon={autoAddItemsModal} onActivate={onAutoAddActivate} />
		</CouponContext.Provider>
	);
};

export { CouponContext, CouponContextProvider };
